<template>
    <div class="contents m-b-20">
      <p class="brder-b m-b-20 title">猜你喜欢</p>
      <ul class="ulList flex-row-wrap">
          <li class="item">
              <img :src="lion" alt="">
              <p>促欧派橱柜整体橱柜定做小户型橱柜现代厨房橱柜定制北欧风现代厨房橱柜定制北欧风简</p>
          </li>
          <li class="item">
              <img :src="lion" alt="">
              <p>促欧派橱柜整体橱柜定做小户型橱柜现代厨房橱柜定制北欧风简</p>
          </li>
          <li class="item">
              <img :src="lion" alt="">
              <p>促欧派橱柜整体橱柜定做小户型橱柜现代厨房橱柜定制北欧风简</p>
          </li>
          <li class="item">
              <img :src="lion" alt="">
              <p>促欧派橱柜整体橱柜定做小户型橱柜现代厨房橱柜定制北欧风简</p>
          </li>
          <li class="item">
              <img :src="lion" alt="">
              <p>促欧派橱柜整体橱柜定做小户型橱柜现代厨房橱柜定制北欧风简</p>
          </li>
          <li class="item">
              <img :src="lion" alt="">
              <p>促欧派橱柜整体橱柜定做小户型橱柜现代厨房橱柜定制北欧风简</p>
          </li>
          <li class="item">
              <img :src="lion" alt="">
              <p>促欧派橱柜整体橱柜定做小户型橱柜现代厨房橱柜定制北欧风简</p>
          </li>
          <li class="item">
              <img :src="lion" alt="">
              <p>促欧派橱柜整体橱柜定做小户型橱柜现代厨房橱柜定制北欧风简</p>
          </li>
      </ul>
    </div>    
</template>
<script>
import lion from '@/assets/img/lion.jpg'
export default {
    name: 'contents',
    data(){
        return {
            lion,
        }
    }
}
</script>
<style lang="scss" scoped>
.contents{
    background: $ffff;
    .title{
        height: 62px;
        font-size:30px;
        color:$color-51;
        line-height:70px;
        margin: 0 20px;
        padding-left: 16px;
        &::before{
        content: '';
        width:4px;
        height:20px;
        display: inline-block;
        margin-right: 17px;
        background:$color-155;
        }
    }
    .ulList{
        margin: 20px 35px 0 35px;
        justify-content:space-between;
        .item{
            width: calc((100%-24px)/2);
            margin-bottom: 33px;
            text-align: center;
            img{
                width: 326px;
                height: 250px;
                margin-bottom: 13px;
            }
            p{
                width:307px;
                height:56px;
                font-size:22px;
                color:$color-153;
                line-height:30px;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
            }
        }
    }
}
</style>
